import React, { useEffect, useState } from 'react';
import './ValidationReferencesResultInfo.scss';
import IconItem from '../../../../../../components/Item/IconItem/IconItem';
import { faClose, faList } from '@fortawesome/free-solid-svg-icons';
import DefaultButton from 'components/buttons/DefaultButton/DefaultButton';
import { Trans, useTranslation } from 'react-i18next';
import { formatNumberWithSpaces } from 'utils/utils';
import { IImportFileNew, IParts } from 'interfaces/price';
import CURRENCY from 'utils/constants/currency';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch } from 'react-redux';
import { setCloseModal, setOpenProformaAutomotorModal } from 'store/slices/proformaAutomotorModal.slice';
import { IFileRow } from 'applications/automotor/views/espace-automotor-order/automotor-order.mode';

type Props = {
  setOpenModal: (e: boolean) => void;
  setStepModal: (e: string) => void;
  stepModalNext: string;
};


const ValidationReferencesResultInfo: React.FC<Props> = (props) => {

  const { t } = useTranslation();
  const proformaFile = JSON.parse(localStorage.getItem('proformaFileInProgress') as string);
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [totalVolume, setTotalVolume] = useState<number>(0);
  const [totalWeight, setTotalWeight] = useState<number>(0);
  const [madeIn, setMadeIn] = useState<string[]>([]);
  const user = JSON.parse(localStorage.getItem('userData')!);
  const dispatch = useDispatch();
  const [totalOrderValidate, setTotalOrderValidate] = useState<Number | null>(null);
  const referencesConfirmed = proformaFile.partsWithReplacements || [];
  const [hasRen, setHasRen] = useState(false);
  const referencesNotFound = proformaFile.rows.filter((row) => row.section !== 'PRICE_OK') || [];

  const handleClose = () => {
    props.setOpenModal(false);
    dispatch(setCloseModal(true));
  };

  useEffect(() => {
    if (proformaFile) {
      reorganiseOrder();
    }
  }, []);

  const reorganiseOrder = async () => {

    const data = proformaFile?.partsWithReplacements || [];
    const validParts = validateParts(data);

    if (validParts.validateTotalOrder) {

      const proformaBody = await filterParts(data);

      proformaFile.order_items = proformaBody;
      proformaFile.order_items_estimation = await partNotOkFromReferencesConfirmed(validParts.validateTotalOrder);

    } else {

      proformaFile.rows = [];
      proformaFile.order_items_estimation = await partNotOkFromReferencesConfirmed(validParts.validateTotalOrder);

    }

    let price = 0;
    let volume = 0;
    let weight = 0;
    const madeInSet = new Set<string>(); //structură de date care nu permite duplicate.
    const hasRenCodFou = proformaFile.order_items.some((item) => item.info?.codfou === 'REN');
    const excludeRenCodFou = proformaFile.order_items.filter((item) => item.info?.codfou !== 'REN');

    excludeRenCodFou.forEach((item) => {
      price += Number(item.data[6]) * Number(item.data[7]);
      volume += Number(item.data[6]) * (Number(item.info?.volume) || 0);
      weight += Number(item.data[6]) * (Number(item.info?.weight) || 0);

      if (item.info?.country_name) {
        madeInSet.add(item.info.country_name);
      }

    });

    setTotalPrice(price);
    setTotalVolume(volume);
    setTotalWeight(weight);
    setMadeIn(Array.from(madeInSet)); // Convertim Set-ul în array
    setHasRen(hasRenCodFou);

    localStorage.setItem('proformaFileInProgress', JSON.stringify({ ...proformaFile }));
  };


  const handleSubmit = () => {
    props.setStepModal('SubmitOrder');

  };

  const addComment = () => {
    props.setStepModal('ValidationReferencesResultInfoComment');

  };


  const filterParts = async (referencesConfirmed) => {


    const newData = referencesConfirmed.map((items) => {
      const result_parts = items.parts.filter((item) => {
        if (item.ind_equivalence && item.ind_equivalence_select) {
          // return (item.ind_equivalence.quantity! >= item.ind_equivalence.min_quantity && item.ind_equivalence.quantity! % item.ind_equivalence.uv! == 0)
          //     && ((item.ind_equivalence.max_quantity != null && (item.ind_equivalence.quantity! > item.ind_equivalence.max_quantity)) || item.ind_equivalence.max_quantity == null);
          return (item.ind_equivalence.quantity! >= item.ind_equivalence.min_quantity)
            && ((item.ind_equivalence.max_quantity != null && (item.ind_equivalence.quantity! > item.ind_equivalence.max_quantity)) || item.ind_equivalence.max_quantity == null);

        } else {
          // return (item.quantity! >= item.min_quantity && item.quantity! % item.uv! == 0)
          //     && ((item.max_quantity != null && (item.quantity! < item.max_quantity)) || item.max_quantity == null);
          return (item.quantity! >= item.min_quantity)
            && ((item.max_quantity != null && (item.quantity! < item.max_quantity)) || item.max_quantity == null);
        }


      });

      const objCopy = { ...items };

      objCopy.parts = result_parts;

      return objCopy;
    });

    //delete supplier if it has no parts
    const newDataSupplier = newData.filter((item) => {
      return item.parts.length !== 0;
    });

    //delete supplier if franco is lower

    const dataValidate = newDataSupplier.map((item) => {

      let total_provider = 0;
      const validate_ind_franco = {};

      item.parts.map((i) => {

        if (i.ind_equivalence && i.ind_equivalence_select) {
          if (!Object.keys(validate_ind_franco).some((key) => key === i.ind_equivalence.company)) {
            validate_ind_franco[i.ind_equivalence.company] = { total: i.ind_equivalence.total, franco: i.ind_equivalence.franco };
          } else {
            validate_ind_franco[i.ind_equivalence.company].total += i.ind_equivalence.total;
          }
        } else {
          total_provider = Number(total_provider) + Number(i.total);
        }
      });


      const result_parts = item.parts.filter((i) => {
        if (i.ind_equivalence && i.ind_equivalence_select) {
          return Object.keys(validate_ind_franco).includes(i.ind_equivalence.company) && (validate_ind_franco[i.ind_equivalence.company].franco <= validate_ind_franco[i.ind_equivalence.company].total);
        } else {
          return total_provider >= item.franco!;
        }
      });

      const objCopy = { ...item };

      objCopy.parts = result_parts;

      return objCopy;
    });

    //delete supplier if it has no parts
    const newDataValidate = dataValidate.filter((item) => {
      return item.parts.length !== 0;
    });

    const dataParts: IParts[] = [];

    newDataValidate.map((item) => {
      item.parts.map((part) => {
        part.supplier_logo = item.supplier_logo;
        part.supplier_name = item.name;
        dataParts.push(part);
      });
    });

    const PRICE_OK = dataParts.filter((item) => item.price !== null || item.price !== 0);
    let proformaBody;

    if (PRICE_OK.length) {
      proformaBody = PRICE_OK.map((item, index) => {
        if (item.ind_equivalence && item.ind_equivalence_select) {

          return {
            data: [index, '', (item.ind_equivalence?.reference_internal ? item.ind_equivalence?.reference_internal : ''), item.ind_equivalence.codfou, item.ind_equivalence.reference_full, item.ind_equivalence.description, item.ind_equivalence.quantity, item.ind_equivalence.price],
            info: {
              is_manufacturer: item.ind_equivalence.source === 'sup' ? 0 : 1,
              supplier_id: item.ind_equivalence.supplier_id,
              description: item.ind_equivalence.description,
              country_restriction: (item.ind_equivalence.country_restriction != null ? true : false),
              itgr: item.ind_equivalence.itgr,
              old_reference: item.old_reference ? item.old_reference : (item.replace_status ? item.replace?.reference : null),
              made_in: item.ind_equivalence.made_in,
              country_name: item.ind_equivalence.country_name,
              weight: item.ind_equivalence.weight,
              volume: item.ind_equivalence.volume,
              codfou: item.ind_equivalence.codfou,
              supplier_logo: item.ind_equivalence.supplier_logo,
              supplier_name: item.ind_equivalence.name,
              reference_full: item.ind_equivalence.reference_full,
              quantity: item.ind_equivalence.quantity,
              price: item.ind_equivalence.price
            },
            section: 'PRICE_OK',
          };
        } else {
          return {
            data: [index, '', item.reference_internal, item.codfou, item.reference_full, item.description, item.quantity, item.price],
            info: {
              is_manufacturer: item.source === 'sup' ? 0 : 1,
              description: item.description,
              supplier_id: item.supplier_id,
              country_restriction: (item.country_restriction != null ? true : false),
              itgr: item.itgr,
              old_reference: item.old_reference ? item.old_reference : (item.replace_status ? item.replace?.reference : null),
              made_in: item.made_in,
              country_name: item.country_name,
              weight: item.weight,
              volume: item.volume,
              codfou: item.codfou,
              supplier_logo: item.supplier_logo,
              supplier_name: item.name,
              reference_full: item.reference_full,
              quantity: item.quantity,
              price: item.price
            },
            section: 'PRICE_OK',
          };
        }

      });
    } else {
      proformaBody = [];
    }

    return proformaBody;
  };

  const validateParts = (references: IImportFileNew[]) => {

    let validateProforma = true;
    const validateTotalOrder = true;
    const errornotValid: Array<string> = [];

    const validate_ind_franco = {};


    references.map((items) => {
      let total_provider_franco = 0;
      let total_provider = 0;


      items.parts.map((i) => {
        if (i.ind_equivalence && i.ind_equivalence_select) {
          if (!Object.keys(validate_ind_franco).some((key) => key === i.ind_equivalence?.company)) {
            validate_ind_franco[i.ind_equivalence.company] = { total: i.ind_equivalence.total, franco: i.ind_equivalence.franco };
          } else {
            validate_ind_franco[i.ind_equivalence.company].total += i.ind_equivalence.total;
          }
        } else {
          if (Number(i.quantity) >= i.min_quantity && Number(i.quantity) % i.uv == 0) {
            total_provider += 1;
            total_provider_franco += Number(i.total);
          }
        }
      });

      if (total_provider_franco < Number(items.franco) && total_provider != 0 && items.name != 'NOT_SUPPLIED') {
        validateProforma = false;
        errornotValid.push(t('_min_franco'));
      }

      items.parts.map((item) => {


        if (item.ind_equivalence && item.ind_equivalence_select) {
          if (Number(item.ind_equivalence.quantity) < item.ind_equivalence.min_quantity && items.name != 'NOT_SUPPLIED') {
            validateProforma = false;
            errornotValid.push(t('_min_quantity'));
          }

          if (item.max_quantity != null && (Number(item.ind_equivalence.quantity) > Number(item.ind_equivalence.max_quantity)) && items.name != 'NOT_SUPPLIED') {
            validateProforma = false;
            errornotValid.push((item.ind_equivalence.max_quantity <= 0 ? t('_validate_max_quantity_negative') : t('_validate_max_quantity')));

          }

          if (Number(item.ind_equivalence.quantity) % item.ind_equivalence.uv != 0 && items.name != 'NOT_SUPPLIED') {
            validateProforma = false;
            errornotValid.push(t('_validate_uv'));
          }
        } else {
          if (Number(item.quantity) < item.min_quantity && items.name != 'NOT_SUPPLIED') {

            validateProforma = false;
            errornotValid.push(t('_min_quantity'));
          }

          if (item.max_quantity != null && (Number(item.quantity) > Number(item.max_quantity)) && items.name != 'NOT_SUPPLIED') {

            validateProforma = false;
            errornotValid.push((item.max_quantity <= 0 ? t('_validate_max_quantity_negative') : t('_validate_max_quantity')));
          }

          if (Number(item.quantity) % item.uv != 0 && items.name != 'NOT_SUPPLIED') {
            validateProforma = false;
            errornotValid.push(t('_validate_uv'));
          }
        }
      });

      Object.keys(validate_ind_franco).forEach((key) => {
        if (validate_ind_franco[key].total < validate_ind_franco[key].franco) {
          validateProforma = false;
          errornotValid.push(t('_min_franco') + key);
        }
      });
    });

    //const total_price = getTotalPriceConfirmeted(referencesConfirmed);

    // if (totalOrderValidate && total_price < Number(totalOrderValidate)) {
    //   errornotValid.push(t('_min_total_order') + ' ' + `${CURRENCY[user!.currency]}${Number(totalOrderValidate).toFixed(2)}`);
    //   validateProforma = false;
    //   validateTotalOrder = false;
    // }


    return { validateProforma: validateProforma, errornotValid: errornotValid.filter((x, i, a) => a.indexOf(x) == i), validateTotalOrder: validateTotalOrder };
  };

  const getTotalPriceConfirmeted = (references: IImportFileNew[]) => {
    let total_price = 0;

    references.map((item) => {
      item.parts.map((i) => {
        if (i.ind_equivalence && i.ind_equivalence_select) {
          if (
            Number(i.ind_equivalence.quantity) >= i.ind_equivalence.min_quantity &&
            Number(i.ind_equivalence.quantity) % i.ind_equivalence.uv == 0
          ) {
            total_price += Number(i.ind_equivalence.total);
          }
        } else {
          if (Number(i.quantity) >= i.min_quantity && Number(i.quantity) % i.uv == 0) {
            total_price += Number(i.total);
          }
        }
      });
    });

    return total_price;
  };

  const partNotOkFromReferencesConfirmed = async (validateTotalOrder: boolean) => {

    const partNotOK: {
      minimum_quantity_not_respect: IParts[];
      franco_not_respect: IParts[];
      minimum_total_order: IParts[],
      maximum_quantity_not_respect: IParts[];
      item_unavailable: IParts[];
    } = {
      franco_not_respect: [],
      minimum_quantity_not_respect: [],
      minimum_total_order: [],
      maximum_quantity_not_respect: [],
      item_unavailable: []
    };

    referencesConfirmed.map((items) => {

      let total_provider = 0;
      const validate_ind_franco = {};

      items.parts.map((i) => {

        if (i.ind_equivalence && i.ind_equivalence_select) {
          if (!Object.keys(validate_ind_franco).some((key) => key === i.ind_equivalence.company)) {
            validate_ind_franco[i.ind_equivalence.company] = { total: i.ind_equivalence.total, franco: i.ind_equivalence.franco };
          } else {
            validate_ind_franco[i.ind_equivalence.company].total += i.ind_equivalence.total;
          }
        } else {
          total_provider = Number(total_provider) + Number(i.total);
        }
      });


      items.parts.map((item) => {

        if (validateTotalOrder) {
          if (item.ind_equivalence && item.ind_equivalence_select) {
            if (item.ind_equivalence.quantity! < item.ind_equivalence.min_quantity && item.ind_equivalence.quantity! % item.ind_equivalence.uv! == 0) {
              partNotOK['minimum_quantity_not_respect'].push(item);
            }

            if (item.ind_equivalence.max_quantity && (item.ind_equivalence.quantity! > item.ind_equivalence.max_quantity)) {

              if (item.ind_equivalence.max_quantity <= 0) {
                partNotOK['item_unavailable'].push(item);
              } else {
                partNotOK['maximum_quantity_not_respect'].push(item);
              }

            }

            if (Object.keys(validate_ind_franco).includes(item.ind_equivalence.company) && (validate_ind_franco[item.ind_equivalence.company].franco > validate_ind_franco[item.ind_equivalence.company].total)) {
              partNotOK['franco_not_respect'].push(item);
            }
          } else {
            if (item.quantity! < item.min_quantity && item.quantity! % item.uv! == 0) {
              partNotOK['minimum_quantity_not_respect'].push(item);
            }

            if (item.max_quantity != null && (item.quantity! > item.max_quantity)) {

              if (item.max_quantity <= 0) {
                partNotOK['item_unavailable'].push(item);
              } else {
                partNotOK['maximum_quantity_not_respect'].push(item);
              }
            }

            if (total_provider < item.franco!) {
              partNotOK['franco_not_respect'].push(item);
            }
          }


        } else {
          partNotOK['minimum_total_order'].push(item);
        }

      });

    });


    const partNotOKnew: Array<IFileRow> = [];

    Object.keys(partNotOK).map((sectionKey) => {
      partNotOK[sectionKey].map((item, k) => {

        if (item.ind_equivalence && item.ind_equivalence_select) {
          partNotOKnew.push({
            data: [referencesNotFound.length + k, '', (item.ind_equivalence?.reference_internal ? item.ind_equivalence?.reference_internal : ''), item.ind_equivalence.codfou, item.ind_equivalence.reference_full, item.ind_equivalence.description, item.ind_equivalence.quantity, item.ind_equivalence.price],
            info: {
              codfou: item.ind_equivalence.codfou,
              current_price: item.ind_equivalence.price,
              description: item.ind_equivalence.description,
              is_manufacturer: Number(0),
              price_from_file: Number(item.price_from_file),
              reference: item.ind_equivalence.reference,
              supplier_id: item.ind_equivalence.supplier_id,
              supplier_name: item.ind_equivalence.supplier_cod_fou,
              itgr: item.ind_equivalence.itgr,
              old_reference: item.old_reference ? item.old_reference : (item.replace_status ? item.replace?.reference : null),
              made_in: item.ind_equivalence.made_in,
              weight: item.ind_equivalence.weight,
              volume: item.ind_equivalence.volume,
            },
            section: sectionKey.toUpperCase(),
            isRemovedByUser: false
          });
        } else {
          partNotOKnew.push({
            data: [referencesNotFound.length + k, '', item.reference_internal, item.codfou, item.reference_full, item.description, item.quantity, item.price],
            info: {
              codfou: item.codfou,
              current_price: item.current_price,
              description: item.description,
              is_manufacturer: Number(item.is_manufacturer),
              price_from_file: Number(item.price_from_file),
              reference: item.reference,
              supplier_id: item.supplier_id,
              supplier_name: item.supplier_name || item.name,
              itgr: item.itgr,
              old_reference: item.old_reference ? item.old_reference : (item.replace_status ? item.replace?.reference : null),
              made_in: item.made_in,
              weight: item.weight,
              volume: item.volume,
            },
            section: sectionKey.toUpperCase(),
            isRemovedByUser: false
          });
        }


      });
    });

    return [...referencesNotFound, ...partNotOKnew];

  };

  const handleReplaceFile = () => {
    dispatch(setOpenProformaAutomotorModal(true));
    dispatch(setCloseModal(true));
    props.setOpenModal(false);

  };


  return (
    <div className="validation-custumer-order-result-info-modal" >
      <div className="close upload_order_result_info_close">
        <IconItem icon={faClose} onClick={() => { handleClose(); }} />
      </div>
      <div className="validation-customer-modal-body">
        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-title">{(totalPrice || hasRen) ? t('_ref_result_info') : t('_your_order_is_invalid')}</div>
          <div className="validation-customer-modal-subtitle">
            { }
            <Trans i18nKey={totalPrice ? '_ref_result_info_message' : hasRen ? '_ref_result_info_message_invalid_hasRen' : '_ref_result_info_message_invalid'} components={{ bold: <br /> }} />
          </div>
        </div>

        {totalPrice ?
          <div className="validation-customer-modal-row">
            <div className="validation-customer-modal-info">
              {/* {(proformaFile?.price_mapped == false)
                ?  */}
              < div className="upload_order_result_info_show_list_details" onClick={() => { props.setStepModal('ValidationReferencesSummary'); }} >
                <FontAwesomeIcon icon={faList} /> {t('_summary_screen_of_the_order')}
              </div>
              {/* : null
               } */}


              <div className="validation-customer-modal-info-row">
                <div className="validation-customer-modal-info-title"> *{t('_ref_total_price')}  </div> :
                <div className="validation-customer-modal-info-value">{totalPrice ? formatNumberWithSpaces(Number(totalPrice).toFixed(2)) + ' ' + CURRENCY[user!.currency] : '-'}</div>
              </div>
              {totalVolume ?
                <div className="validation-customer-modal-info-row">
                  <div className="validation-customer-modal-info-title"> *{t('_ref_total_volume')}</div> :
                  <div className="validation-customer-modal-info-value">{totalVolume ? formatNumberWithSpaces(Number(totalVolume).toFixed(2)) + ' (m3)' : '-'}</div>
                </div>
                : null}
              {totalWeight ?
                <div className="validation-customer-modal-info-row">
                  <div className="validation-customer-modal-info-title">*{t('_ref_total_weight')}</div> :
                  <div className="validation-customer-modal-info-value">{totalWeight ? formatNumberWithSpaces(Number(totalWeight).toFixed(2)) + ' Kg' : '-'}</div>
                </div>
                : null}
            </div>
            {madeIn.length ?
              <React.Fragment>
                <hr />
                <div className="validation-customer-modal-info">
                  <div className="validation-customer-modal-info-row">

                    <div className="validation-customer-modal-info-row-made-in">

                      <div className="validation-customer-modal-info-title"> {t('_ref_made_in')} :</div>
                      <div className="validation-customer-modal-info-value"> {madeIn.length ? madeIn.join(', ') : t('_no_found_country')}</div>
                    </div>
                  </div>
                </div>
              </React.Fragment>
              : null}


          </div>
          : null}

        <div className="validation-customer-modal-row">
          <div className="validation-customer-modal-button">
            {totalPrice || hasRen ?
              <React.Fragment>
                <DefaultButton className="validation-customer-modal-btn upload_order_result_info_send_order" text={t('_send_my_order_as_is')} onClick={() => { handleSubmit(); }} />
                <DefaultButton className="validation-customer-modal-btn upload_order_result_info_add_comment" text={t('_ref_result_info_comment')} onClick={() => { addComment(); }} />
              </React.Fragment>
              : <DefaultButton className="customer-modal-btn upload_order_info_replace_existing_file" text={t('_load_a_new_command_file')} onClick={() => { handleReplaceFile(); }} />
            }
            <DefaultButton className="validation-customer-modal-btn cancel upload_order_result_info_cancel" text={t('_cancel')} onClick={() => { handleClose(); }} />
          </div>

        </div>


      </div>
      {totalPrice || hasRen ?
        <div className="validation-customer-modal-info-subtitle">
          {t('_info_fournisseur_sujet_variable')}
        </div> : null
      }
    </div >
  );

};

ValidationReferencesResultInfo.displayName = 'ValidationReferencesResultInfo';

export default ValidationReferencesResultInfo;